import { render, staticRenderFns } from "./SubscriptionSettings.vue?vue&type=template&id=5f7652ff&scoped=true&"
import script from "./SubscriptionSettings.vue?vue&type=script&lang=js&"
export * from "./SubscriptionSettings.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionSettings.vue?vue&type=style&index=0&id=5f7652ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7652ff",
  null
  
)

export default component.exports